import styled from 'styled-components'
import ContactForm from 'src/form/ContactForm'
import { mq, pxToRem, sizes } from 'src/theme'

import BlockTitle from '../BlockTitle'
import ActionButton from '../ActionButton'

export const Container = styled.section`
  --padding-block: ${pxToRem(32)};
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(56)};
  padding-block: var(--padding-block);
  padding-inline: ${pxToRem(16)};
  align-items: center;
  &:not(:first-child) {
    // no idea on the first values came to be so: magic numbers
    margin-block-start: calc(
      var(--g_spacing__blocks) - var(--padding-block) - 2rem
    );
  }
  @media ${mq(sizes.desktop)} {
    --padding-block: ${pxToRem(80)};
    gap: ${pxToRem(40)};
    padding-inline: ${pxToRem(32)};
  }

  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(144)};
  }
`
export const BlockTitleStyled = styled(BlockTitle)``
export const Wrapper = styled.div`
  @media ${mq(sizes.desktop)} {
    width: 100%;
    max-width: calc(2 / 3 * 100%);
    margin-inline-start: auto;
  }
`
export const Form = styled(ContactForm)`
  max-width: ${pxToRem(564)};
`
export const Reset = styled(ActionButton)``
